import TranslateRoundedIcon from '@mui/icons-material/TranslateRounded'
import { Select } from '../components/Common'
import { NLS_LOCALE_LABELS, NLS_MAJOR_LOCALES } from './localePolicy'
import type { NlsLocale } from './nlsTypes'
import { useNls } from './nlsProvider'

type NlsLocaleSelectProps = {
  className?: string
  /** Kept for backwards-compat with callers; no visual effect anymore. */
  compact?: boolean
}

export const NlsLocaleSelect = ({ className }: NlsLocaleSelectProps) => {
  const { locale, setLocale, t } = useNls()

  const options = NLS_MAJOR_LOCALES.map((o) => ({
    value: o,
    label: NLS_LOCALE_LABELS[o].nativeLabel,
  }))

  return (
    <Select
      trigger="labeledPill"
      className={['nlsLocaleSelect', className].filter(Boolean).join(' ')}
      label={<TranslateRoundedIcon fontSize="small" aria-hidden="true" />}
      value={locale}
      options={options}
      onChange={(next) => setLocale(next as NlsLocale)}
      ariaLabel={t('NLSCommonLanguageAriaLabel')}
    />
  )
}
